var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "aiwriter"
  }, [_c("section", {
    staticClass: "aiwriter-banner",
    style: {
      background: `url(${_vm.bannerData.imageUrl}) no-repeat center 0px`,
      backgroundSize: "cover"
    }
  }, [_c("Banner", {
    attrs: {
      imageUrl: _vm.bannerData.imageUrl,
      title: _vm.bannerData.bannerTitle,
      description: _vm.bannerData.bannerText
    }
  })], 1), _c("section", {
    staticClass: "function"
  }, [_c("div", {
    staticClass: "function-main"
  }, [_c("Title", {
    attrs: {
      title: "产品功能"
    }
  }), _c("div", {
    staticClass: "function-main-card"
  }, _vm._l(_vm.functionsData, function (item, index) {
    return _c("BusiCard", {
      key: index,
      attrs: {
        title: item.title,
        desc: item.text,
        cardWidth: "410px",
        cardHeight: "352px",
        img: item.icon,
        dark: true
      }
    });
  }), 1)], 1)]), _c("section", {
    staticClass: "businesses"
  }, [_c("div", {
    staticClass: "businesses-main"
  }, [_c("Title", {
    attrs: {
      title: "业务场景"
    }
  }), _c("div", {
    staticClass: "businesses-main-card"
  }, _vm._l(_vm.businessesData, function (item, index) {
    return _c("BusiCard", {
      key: index,
      attrs: {
        title: item.title,
        desc: item.text,
        cardWidth: "302px",
        img: item.icon
      }
    });
  }), 1)], 1)]), _c("section", {
    staticClass: "advantages"
  }, [_c("div", {
    staticClass: "advantages-main"
  }, [_c("Title", {
    attrs: {
      title: "产品优势"
    }
  }), _c("Advantages2", {
    attrs: {
      leftItems: _vm.leftItems,
      rightItems: _vm.rightItems
    }
  })], 1)]), _c("Appointment2")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };